let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ihURd")).then(() => parcelRequire('4PIVt'));